import { createSlice } from "@reduxjs/toolkit";
import { getActionResolutions, getActionResolutionsPag, getMasterActionResolutions } from "./thunks";
import { logOut } from "../authentication/authenticationSlice";

const initialState = {
  actionResolutions: {},
  list: [],
  listPag: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: [],
  },
  loading: "idle",
  loadingPag: "idle",
  error: null,
};

const actionResolutionsSlice = createSlice({
  name: "actionResolutions",
  initialState,
  extraReducers: {
    [getMasterActionResolutions.pending]: (state) => {
      state.loading = "loading";
      state.error = null;
    },
    [getMasterActionResolutions.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.actionResolutions = action.payload;
    },
    [getMasterActionResolutions.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [getActionResolutions.pending]: (state) => {
      state.loading = "loading";
      state.error = null;
    },
    [getActionResolutions.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.list = action.payload;
    },
    [getActionResolutions.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [getActionResolutionsPag.pending]: (state) => {
      state.loading = "loadingPag";
      state.error = null;
    },
    [getActionResolutionsPag.fulfilled]: (state, action) => {
      state.loadingPag = "succeeded";
      state.listPag.elements = action.payload.elements;
      state.listPag.pageIndex = action.payload.pageIndex;
      state.listPag.pageSize = action.payload.pageSize;
      state.listPag.totalRecords = action.payload.totalRecords;
      state.listPag.totalPages = action.payload.totalPages;
      state.listPag.hasPreviousPage = action.payload.hasPreviousPage;
      state.listPag.hasNextPage = action.payload.hasNextPage;
    },
    [getActionResolutionsPag.rejected]: (state, action) => {
      state.loadingPag = "failed";
      state.error = action.error.message;
    },
    [logOut]: () => initialState,
  },
});

export default actionResolutionsSlice.reducer;
